var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-sidebar',{attrs:{"id":"sidebar-ToolBar","right":"","no-header":"","backdrop":"","bg-variant":"transparent","backdrop-variant":"dark"}},[_c('div',{attrs:{"id":"ToolBar"}},[_c('div',[_c('EmpolyGroup'),_c('CallInHistoryv2')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }